import {
	GetTimeserieData,
	GetTimeserieMetadata,
	TimeserieDataResp,
	TimeserieMetadataResp,
} from "./types";
import contractManagementGecoApi from "../contractManagementGecoApi";

const service = contractManagementGecoApi.injectEndpoints({
	endpoints: (builder) => ({
		getTimeseriesMetadata: builder.query<
			TimeserieMetadataResp[],
			GetTimeserieMetadata
		>({
			query: ({
				endpoint,
				resourceType,
				resourceId,
				kind,
				type,
				variant,
				maturity,
				startDate,
				endDate,
			}) => ({
				url: `${
					endpoint || ""
				}/${resourceType}/${resourceId}/timeseries`,
				method: "GET",
				params: {
					field_data_kind: kind,
					field_data_type: type,
					field_data_variant: variant,
					field_data_maturity: maturity,
					start_date: startDate,
					end_date: endDate,
				},
			}),
		}),
		getTimeseriesData: builder.query<TimeserieDataResp[], GetTimeserieData>(
			{
				query: ({
					endpoint,
					timeserieId,
					unit,
					simplingRate,
					startDate,
					endDate,
				}) => ({
					url: `${endpoint || ""}/timeseries/data`,
					method: "GET",
					params: {
						field_data_ids: timeserieId,
						unit: unit,
						sampling_rate: simplingRate,
						start_date: startDate,
						end_date: endDate,
					},
				}),
			}
		),
	}),
});

export const {
	useGetTimeseriesMetadataQuery,
	useLazyGetTimeseriesMetadataQuery,
	useLazyGetTimeseriesDataQuery,
} = service;

export default service;
